import React, { useContext } from "react";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";
import OutsourceTracking from "../OutsourceTracking";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import { Provider } from "../../../../data/entities";
import FormContainer from "../Content";
import MaterialList from "../../create/Content/MaterialList";

interface TabNavigationProps {
    validated: boolean;
    providerData: Provider;
    mergeProvider: Function;
}

const TabNavigation = ({
    validated,
    providerData,
    mergeProvider,
}: TabNavigationProps) => {
    const { user: { role } } = useContext(AuthenticationContext);
    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: (
                <FormContainer
                    validated={validated}
                    providerData={providerData}
                    mergeProvider={mergeProvider}
                />
            ),
        },
        {
            label: "Vật tư cung cấp",
            labelEN: "select-materials",
            content: (
                <MaterialList
                    providerData={providerData}
                    mergeProvider={mergeProvider}
                />
            ),
        },
        {
            label: "Vật tư gia công",
            labelEN: "outsource-materials",
            content: (
                <MaterialList
                    providerData={providerData}
                    mergeProvider={mergeProvider}
                    relationKey="outsource_materials"
                    title="Danh sách vật tư gia công"
                    counterLabel="vật tư gia công"
                    priceColumnLabel="Giá gia công"
                    addButtonLabel="Thêm vật tư gia công"
                    emptyText="Không có vật tư gia công nào được chọn"
                    searchPlaceholder="Tìm kiếm vật tư gia công..."
                />
            ),
        },
    ];

    if ([ROLE.MANAGER, ROLE.PURCHASING_STAFF, ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role)) {
        tabs.push({ label: "Theo dõi gia công", labelEN: "outsource-tracking", content: <OutsourceTracking key={providerData.id} providerId={providerData.id} /> });
    }
    return <TabBar tabs={tabs} />;
};

export default TabNavigation;
